// src/components/store/sections/weekly-banner/WeeklyBannerV34MagazineissueCoralFlame.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV34MagazineissueCoralFlame(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={34}
      archKey="magazine_issue"
      archLabel="Editorial Issue Banner"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      {...props}
    />
  );
}
